import React from 'react';

import SearchInputModal from './modal'
import useModal from '../../../../../../hooks/useModal';

import SearchText from '../../asset/13-mission2-search.png'

import { 
  SearchArea,
  Wrap,
  SearchWrap,
  TextImg 
} from './styled';

const SearchInput = ({ 
  myAddress, 
  selectMyAddress, 
  mission1Count, 
  isValidAuth 
}) => {
  const { openModal, ModalPortal, closeModal } = useModal();
  
  const clickSearch = () => {
    if (!isValidAuth()) return;

    if (mission1Count === 0) {
      alert('첫번째 미션을 완료한 분들께 드리는 혜택입니다.첫 번째 미션을 먼저 완료해 주세요!');
      return 
    }
    openModal();
  }

  return (
    <Wrap>
      <SearchWrap>
        <TextImg imgUrl={SearchText} />
      </SearchWrap>

      <SearchArea 
        onClick={clickSearch}
        value={myAddress}
      >
        <svg width="17.76" height="17.76" viewBox="0 0 24 24">
          <g fill="none" fillRule="evenodd">
            <path d="M0 0H24V24H0z"/>
            <g stroke="#222222" strokeWidth="1.5" transform="translate(2 2)">
              <circle cx="8" cy="8" r="8"/>
              <path strokeLinecap="round" d="M15 14L19.95 18.95"/>
            </g>
          </g>
        </svg>
        {myAddress || '예) 서초동, 삼청동, 방이동'}
      </SearchArea>
      
      <ModalPortal>
        <SearchInputModal
          selectMyAddress={selectMyAddress} 
          closeModal={closeModal}
        />
      </ModalPortal>
  </Wrap>
  )
}

export default SearchInput;
